import axios from 'axios'

export default class CartNotification {
    constructor() {
        this.cacheDom()
        this.bindEvents()
    }

    cacheDom() {
        this.bodyEl = document.body
        this.cartBag = document.querySelector('.user-menu .bag')
        this.cartPanel = document.querySelector('.cart-panel-overlay')
        this.trigger = document.querySelector('.cart-panel-header button')

        this.cartPanelContent = document.querySelector('.cart-panel-content')
        this.cartPanelFooterTotal = document.querySelector('.cart-panel-footer-total')
    }

    bindEvents() {
        events.subscribe('cart', () => {
            this.fetchCart()
        })

        events.subscribe('open-panel', () => {
            this.trigger.click()
        })

        this.trigger.addEventListener('click', this.toggleCartPanel.bind(this))
        this.cartBag.addEventListener('click', this.toggleCartPanel.bind(this))
    }

    async fetchCart() {
        await axios.get('/').then((response) => {
            const htmlElement = document.createElement('div')
            htmlElement.innerHTML = response.data
            const content = htmlElement.querySelector('.cart-panel-content').innerHTML
            const total = htmlElement.querySelector('.cart-panel-footer-total').innerHTML
            this.render(content, total)
        })

        await axios.get('/cart.js').then((response) => {
            const itemCount = response.data.item_count

            this.cartBag.setAttribute('data-cart-items', itemCount)

            if (itemCount > 0) {
                if (!this.cartBag.classList.contains('show')) {
                    this.cartBag.classList.add('show')
                }
            } else {
                this.cartBag.classList.remove('show')
            }
        })
    }

    toggleCartPanel(event) {
        event.preventDefault()
        this.bodyEl.classList.toggle('overflow-hidden')
        this.cartPanel.classList.toggle('is-visible')
    }

    render(content, total) {
        this.cartPanelContent.innerHTML = content
        this.cartPanelFooterTotal.innerHTML = total
    }
}
